import { constantTree } from "../../../core/events/ConstantTree";

export const trainOfferEvtTree = constantTree({
  Offer: {
    EarnPoints: {
      Get: ""
    },
    ModifySearch: {
      Click: ""
    },
    DateSelector: {
      Click: "",
      Change: "",
      Updation: ""
    },
    FilterSelector: {
      Click: ""
    },
    TrainList: {
      Change: ""
    },
    TrainListLoadMore: {
      Click: ""
    },
    StandardTrainSelector: {
      Select: ""
    },
    PremiumTrainSelector: {
      Select: ""
    },
    TrainSelector: {
      Select: ""
    },
    ContinueToNextStep: "",
    TrainType: {
      Select: "",
      Radio: {
        Change: ""
      }
    },
    Passenger:{
      Set: ""
    },
    Continue: {
      Click: "",
      Trigger: ""
    },
    Upsell: {
      Show: ""
    },
    ContinueBtn: {
      Click: ""
    },
    ModifySearchClose: {
      Click: ""
    },
    Shuttle: {
      Click: ""
    },
    Calender: {
      BestPrice: ""
    },
    ScrollToContinueButton: {
      Trigger: ""
    },
    PassOffer: {
      Get: "",
      SinglePassenger: {
        Change: ""
      },
      MultiPassenger: {
        Apply: ""
      }
    }
  }
})